<template>
  <div class="input-card">
    <div class="background"></div>
    <div class="input-content">
        <div class="input-prompt">
        {{inputMessage }}
        </div>
        <div class="input-text">
        <input v-model="inputValue" />
        </div>
        <div class="button-container">
            <button @click="confirm">确定</button>
            <button @click="cancel">取消</button>
        </div>
    </div>
   
  </div>
</template>

<script>
export default {
  props: {
    inputMessage: {
      type: String,
      required: true
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm', true, this.inputValue);
    },
    cancel() {
      this.$emit('confirm', false,'');
    }
  }
};
</script>

<style scoped>
.background {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  z-index: 10;
}

.input-content {
  position: fixed;
  width: 433px;
  height: 153px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  background-color: white;
  z-index: 20;

  .input-prompt {
    margin-top: 20px;
    margin-left: 20px;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }
  .input-text{
    margin-top: 10px;
    margin-left: 20px;
    input {
      width: 380px;
      height: 32px;
      border: 1px solid #D8D8D8;
      border-radius: 5px;
      padding-left: 10px;
    }

  }

}

.button-container {
  position: absolute;
    bottom: 20px;
    right: 20px;
  display: flex;
  justify-content: flex-end;
  button {
    width: 65px;
    height: 32px;
    margin-left: 10px;
    background: white;
    border-width: 1px;
    border-color: #383434;
    border-radius: 5px;
    
}
button:hover {
  font-weight: bold;
  background: #F5F5F5;
}
}


</style>
